export default "__VITE_ASSET__CjBFWrhF__"